import { ref } from 'vue'

export const refreshCallback = ref<Function>()
